import { z } from "zod/v4";

import { WidgetDtoSchema } from "../../../dtos/widgets";

export const GetWidgetsResponseBodySchema = z.object({
  widgets: WidgetDtoSchema.array().default([]),
});
export type GetWidgetsResponseBodyType = z.infer<
  typeof GetWidgetsResponseBodySchema
>;
